export const lastAccessDateFormat = (dateStr) => {
    if (!dateStr) {
        return null
    }
    const date: Date = new Date(dateStr)

    if (isToday(date)) {
        return 'Today, ' + getTime(date)
    } else if (isYesterday(date)) {
        return 'Yesterday, ' + getTime(date)
    } else {
        return getFullDate(date)
    }
}

const getTime = (date: Date) => {
    try {
        return new Intl.DateTimeFormat('default', {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            timeZoneName: 'short', hour: 'numeric', minute: 'numeric'
        }).format(date)
    } catch (_) {
        // Still using IE6?
        return date.toLocaleTimeString()
    }
}

const getFullDate = (date: Date) => {
    try {
        return new Intl.DateTimeFormat('default', {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            timeZoneName: 'short', hour: 'numeric', minute: 'numeric', year: 'numeric', month: 'long', day: 'numeric'
        }).format(date)
    } catch (e) {
        return date.toLocaleString()
    }
}

const isToday = (someDate: Date) => {
    return isSameDay(someDate, 0)
}

const isYesterday = (someDate: Date) => {
    return isSameDay(someDate, 1)
}

const isSameDay = (someDate: Date, offset: number)  => {
    const today = new Date(Date.now())
    return someDate.getDate() + offset === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear()
}

const MINUTE = 1000 * 60
const HOUR = MINUTE * 60
const DAY = HOUR * 24

/**
 * This function returns the difference of a date object to the current time.
 * Format:
 *  - Xm
 *  - Yh
 *  - Zd
 * @param date
 */
export const renderDateDiff = (date: Date) => {
    const diff = new Date(Date.now()).getTime() - date.getTime()

    if (diff < HOUR) {
        return `${Math.floor(diff / MINUTE )}m`
    } else if (diff < DAY) {
        return `${Math.floor(diff / HOUR )}h`
    } else {
        return `${Math.floor(diff / DAY )}d`
    }
}
